export enum EmployerContactSubmissionChangeTypeEnum {
  Unchanged = 1,
  New = 2,
  Previous = 3
}
